import React from "react";
import Image from "next/image";

/**
 * 해봄 로고(가로형, 라이트 배경용). 2026-09-05 해봄 브랜드 가이드 v3.0 적용 — DQ 로고에서 교체.
 * 크기: 기본 60×24 — 2026-09-06 사용자 결정으로 기존 DQ 로고(아이콘 43×24 + 글자 39×22) 높이에 맞춤.
 * 브랜드 가이드의 "전체 로고 최소 120px" 규정보다 작다(의도된 예외, design/brand.md 참고).
 * 그보다 작은 자리는 심볼 단독(`haebom-symbol.png`).
 * 원본 512×204(webp). 어두운 배경(bg-inverse)에서는 `haebom-horizontal-dark.webp` 를 쓴다.
 * @param variant "light"(기본) | "dark" — 배경이 Deep Ink 일 때만 dark.
 * @param height 세로 px. 기본 24. 가로는 비율(2.51:1)로 계산 — 로고는 항상 높이 기준으로 맞춘다.
 */
function Logo({ variant = "light", height = 24 }: { variant?: "light" | "dark"; height?: number }) {
  const width = Math.round(height * 2.51);
  return (
    <Image
      src={variant === "dark" ? "/images/haebom/haebom-horizontal-dark.webp" : "/images/haebom/haebom-horizontal.webp"}
      alt="해봄"
      width={width}
      height={height}
      priority
    />
  );
}

export default Logo;
